<div class="msg-error">
    <span class="msg-error-title">{{message}}</span>
</div>